export default __webpack_public_path__ + "static/media/search.86f611bb.svg";